/**
 * @typedef {import('../../types').Component} Component
 * @typedef {import('../../types').FeedbackEntity} FeedbackEntity
 */

/**
 *
 * @param {Component[] | null | []} allRequiredComponents - components
 * @param {FeedbackEntity[]}  submittedComponents - components
 * @returns {boolean} is valid
 */
function shouldAllowSubmit(allRequiredComponents, submittedComponents) {
  if (!allRequiredComponents?.length) {
    // ✅ no required components
    return true;
  }
  if (!submittedComponents?.length) {
    // ❌ no submitted components
    return false;
  }

  const allRequiredSubmittedComponents = allRequiredComponents.filter(
    (requiredComponent) =>
      submittedComponents.some(
        (submittedComponent) =>
          submittedComponent.componentId === requiredComponent.componentId,
      ),
  );

  if (allRequiredSubmittedComponents.length !== allRequiredComponents.length) {
    // ❌ not all required components have been submitted');
    return false;
  }
  // ✅ all required components have been submitted
  return true;
}
export default shouldAllowSubmit;
